type CountProps = {
  title: string;
  isLoading: boolean;
  noCount: boolean;
  count?: number;
};

export const Count = ({ title, isLoading, noCount, count }: CountProps) => {
  if (isLoading) {
    return <>{title} (-)</>;
  }

  if (noCount) {
    return <>{title}</>;
  }

  return (
    <>
      {title} ({count})
    </>
  );
};
